import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { getUpdatedFields, toFormattedDate } from "@miplatform/utils";

const groupActivitiesByDateTime = (groupedActivities) => {
  return Object.entries(groupedActivities).reduce((acc, [date, activities]) => {
    acc[date] = activities.reduce((timeGroupedActivities, activity) => {
      const formattedTime = toFormattedDate(activity.createdOn, "LT");
      if (!timeGroupedActivities[formattedTime]) {
        timeGroupedActivities[formattedTime] = [];
      }
      timeGroupedActivities[formattedTime].push(activity);
      return timeGroupedActivities;
    }, {});
    return acc;
  }, {});
};

export const useAddNoteDrawerViewModel = ({
  dirtyFields,
  getValues,
  planDetails,
  area,
  item,
  updateArea,
  handleCloseDrawer,
}) => {
  const [notes, setNotes] = useState({});

  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const getNotes = () => {
    stateManager.run(async () => {
      const response = await homeService.activities.materials.get({
        planId: planDetails.id,
        areaId: area.id,
        materialId: item.id,
      });

      if (response.status === HTTP_STATUSES.OK) {
        const groupedActivities = Object.groupBy(response.data, (data) =>
          toFormattedDate(data.createdOn, "MMMM D YYYY")
        );
        const groupedData = groupActivitiesByDateTime(groupedActivities);
        setNotes(groupedData);
      }
    });
  };

  const handleCreateNote = () => {
    const updatedValues = getUpdatedFields(dirtyFields, getValues());
    const updatedMaterialNotes = area.materials.map((material) =>
      material.materialId === item.id
        ? { ...material, fieldNote: updatedValues.fieldNote }
        : material
    );
    stateManager.run(async () => {
      if (updatedValues?.notes) {
        await homeService.activities.create({
          data: {
            activityType: "Note",
            relatedReferenceId: `home-service/plans/${planDetails.id}/areas/${area.id}/materials/${item.id}`,
            notes: updatedValues.notes,
          },
        });
      }
      if (dirtyFields?.fieldNote || updatedValues?.fieldNote) {
        updateArea(area.id, { materials: updatedMaterialNotes });
      }
      handleCloseDrawer();
    });
  };

  return {
    getNotes,
    notes,
    handleCreateNote,
    isLoading,
  };
};
